module.exports = __webpack_public_path__ + "static/media/argon-react.641e2eb2.png";